import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';
import { GIFT_CARD, GIFT_CARD_TYPE } from '../../../constants';

export function giftcards() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('giftcards.page-load', () => {
    const pageName = GIFT_CARD;
    const pageType = GIFT_CARD_TYPE;
    const primaryCategory = GIFT_CARD;
    const subCategory1 = GIFT_CARD;
    const subCategory2 = GIFT_CARD;

    digitalData.page = {
      pageInfo: {
        pageName,
        pageType,
      },
      category: {
        primaryCategory,
        subCategory1,
        subCategory2,
      },

    };

    setAnalytics(digitalData);
  });
}